import useLenis from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Benefits } from "@/components/site/Benefits";
import { Channels } from "@/components/site/Channels";
import { Manifesto } from "@/components/site/Manifesto";
import { Pricing } from "@/components/site/Pricing";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { Watermark } from "@/components/site/Watermark";

export default function Landing() {
  useLenis();
  return (
    <div className="grain relative min-h-screen bg-[#05050A] font-body text-white">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Benefits />
        <Channels />
        <Manifesto />
        <Pricing />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Watermark />
    </div>
  );
}
